import { useEffect, useFilter } from 'facades'
import fetcher from 'request/stylists/events'
import recordsRequest from 'request/user/booking-records'
import Reviews from './reviews'
import Row from 'components/common/stylist/event-row'
import Faq from 'components/common/intro/faq'

export default function StylistEvents({ breadcrumbs, category }) {
  const { key, getConditionParams, getConditionTagIds, getPathLocations } = useFilter()
  const t = useI18n()
  const { user, ws } = useCurrent()
  const { state, mutate } = useStatic({
    records: [],
    userBookingDic: null,
    fetching: true,
    loadMoreClick: null
  })

  useBodyScroll({
    state,
    mutate,
    isReady: !!key,
    reset: true,
    startLimit: 8,
    limit: 8,
    showLoadMore: true,
    fetcher,
    fetcherParams: () => ({
      conditionParams: getConditionParams(),
      conditionTagIds: getConditionTagIds()
    }),
    resolver: stylist => {
      stylist.$rating = stylist.rating.toFixed(1)
      stylist.$ratingCount = stylist.totalRatingCount.format()
      state.records.push(stylist)
    }
  }, [key, state.userBookingDic])

  useEffect(() => {
    updateBookingRecords()
  }, [user])

  useEffect(() => {
    refreshSocket()
    return disconnectSocket
  }, [ws])

  useTrackPageScroll()

  const refreshSocket = () => {
    if (ws?.readyState !== 1) return
    ws.send(JSON.stringify({ stylistEvent: 'connect' }))
  }
  const disconnectSocket = () => {
    if (ws?.readyState !== 1) return
    ws.send(JSON.stringify({ stylistEvent: 'disconnect' }))
  }

  s.UsedQuotaUpdate = ({ stylistId, usedQuota }) => {
    const stylist = state.records.find(r => r.id == stylistId)
    if (!stylist) return
    if (stylist.usedQuota === usedQuota) return
    stylist.usedQuota = usedQuota
    mutate()
  }

  const updateBookingRecords = async() => {
    if (!user) return mutate({ userBookingDic: null })

    const bookingRecords = await recordsRequest()
    if (!bookingRecords.length) return mutate({ userBookingDic: null })

    state.userBookingDic = bookingRecords.reduce((dic, booking) => {
      const { state, stylistUserId } = booking
      dic[stylistUserId] ||= {}
      dic[stylistUserId][state] = true
      return dic
    }, {})
    mutate()
  }

  const updateCallback = (stylistId, usedQuota) => {
    const stylist = state.records.find(r => r.id == stylistId)
    if (!stylist) return
    if (stylist.usedQuota === usedQuota) return
    stylist.usedQuota = usedQuota
    mutate()
  }

  // const renderTitle = () => {
  //   const name = getConditionTagName()
  //   if (!name) return
  //   const stylistTitle = t('page:events.stylistTitle', { name })

  //   return (
  //     <div className='container px-2 pt-6'>
  //       <div className='text-[1.2rem] md:text-[1.3rem] font-medium pb-6 md:pb-5 text-center md:text-left'>
  //         { stylistTitle }
  //       </div>
  //     </div>
  //   )
  // }

  const renderBody = () => state.records.map(stylist => (
    <Row
      key={ stylist.id }
      stylist={ stylist }
      userBookingDic={ state.userBookingDic }
      bookingSuccessCallback={ updateBookingRecords }
      updateCallback={ updateCallback }
      serviceCategory={ category }
    />
  ))

  const renderLoading = () => {
    if (state.fetching) return <div className='py-5'><C.Loading /></div>
    if (!state.records.length) return (
      <div className='py-5 text-center text-gray-600 mb-16 flex flex-col'>
        <div>{ t('page:stylists.noResult') }</div>
        <div className='py-3'>
          <C.Link href={ h.path.stylistEvents({ force: true }) } className='text-sm text-gray-500'>{ t('page:events.backToList') }</C.Link>
        </div>
      </div>
    )
    if (state.scrollConfig.isFinish) return
    return (
      <div className='pb-5 flex justify-center'>
        <C.Button className='w-[90%] md:w-[16rem]' onClick={ state.loadMoreClick }>載入更多</C.Button>
      </div>
    )
  }

  const renderBreadcrumbs = () => {
    if (!breadcrumbs) return null
    return (<div className='pt-6'>
      <C.Breadcrumb list={ breadcrumbs } />
    </div>
    )
  }

  // const renderCategoryFilter = () => {
  //   const categoryChange = serviceCategory => updateFilter({ key: 'service', value: serviceCategory })

  //   return (
  //     <div className='container flex flex-wrap tracking-widest pt-6'>
  //       { store.stylistEventFilterCategories.map(key => {
  //         const isActive = key === category
  //         const textStyle = () => {
  //           if (isActive) return 'text-white'
  //           return 'text-gray-700'
  //         }
  //         const bgStyle = () => {
  //           if (isActive) return 'bg-gray-700'
  //           return 'border'
  //         }
  //         return (
  //           <div key={ key }
  //             className={ cn('relative mr-3 mb-3 text-sm text-[0.8rem] cursor-pointer py-2 text-center', textStyle()) }
  //             onClick={ () => categoryChange(key) }
  //           >
  //             <div className={ cn('absolute top-0 bottom-0 left-0 right-0 rounded-full', bgStyle()) } />
  //             <div className='relative px-5'>
  //               { t(`common:service.category.${key}`) }
  //             </div>
  //           </div>
  //         )
  //       }) }
  //     </div>
  //   )
  // }

  const tabClick = () => {
    const { city, district } = getPathLocations()
    h.path.go.stylists({ category, city, district })
  }

  return (
    <>
      {/* <div className='bg-gray-100 mb-4'>
        <div className='container px-2'>

          <div className='py-8 text-gray-600 text-center md:text-left'>
            第一次來嗎? 可以參考
            <span onClick={ openRuleClick } className='ml-1 cursor-pointer underline font-medium'>活動辦法</span>

          </div>
        </div>
      </div> */}
      <div className='container'>
        { renderBreadcrumbs()}
      </div>

      <div className='container flex justify-center border-b pt-3 mb-5'>
        <div className='flex flex-1 md:max-w-[22rem] tracking-widest'>
          <div className='py-3 cursor-pointer flex-1 text-center'>
            <div onClick={ tabClick } className='text-gray-500'>{ t('common:breadcrumb.popularStylists') }</div>
          </div>
          <div className='py-3 cursor-pointer flex-1 text-center border-b-2 border-cyan-800'>
            <div className='text-cyan-800'>{ t('common:breadcrumb.stylistEvents') }</div>
          </div>
        </div>
      </div>

      {/* { renderCategoryFilter() } */}
      {/* { renderTitle() } */}
      { renderBody() }
      { renderLoading() }

      <Reviews
        title='設計師評價'
        queryType='guarantee'
        isReadyKey={ key }
        getConditionParams={ getConditionParams }
        getConditionTagIds={ getConditionTagIds }
      />
      <div className='bg-gray-50 mt-12'>
        <Faq />
      </div>
    </>
  )
}
